import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {V2_ACTIVE_COLOR} from '../../config/color';
import SellerModal from '../Modal/SellerModal';
import {seller} from '../../config/api';
import GAEvent from '../../utils/googleAnalytics';
import Arrow from '../../assets/image/arrow.png';

const ArrowButton = styled.button``;

const RankingWrap = styled.div`
  width: 100%;
  margin: 40px 0 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`

const RankingContainer = styled.div`
  width: 470px;
  @media (max-width: 768px) {
    width: 100%;
  }
`

const RankingTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 0 20px;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`

const AlignListing = styled.p`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  &:is(:nth-child(2)) {
    flex: 3
  }
`

const RankingList = styled.div`
  width: 100%;
  margin: 14px 0 24px;
  background-color: white;
  border-radius: 15px;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    ${ArrowButton} {
      width: 40px;
      padding: 10px;
      background-color: white;

      img {
        width: 100%;
      }
    }
  }
`

const RankingListItem = styled.button`
  width: 100%;
  outline: none;
  background-color: white;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  border-bottom: 1px solid #E5E5E5;
  font-size: 20px;
  cursor: pointer;


  @media (max-width: 768px) {
    font-size: 14px;
    padding: 12px 0;
  }
`

const RankingDes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${V2_ACTIVE_COLOR};
  line-height: 24px;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 18px;
    text-align: center;
  }
`

export default (props) => {
  const [sellerInfo, setSellerInfo] = useState(null);
  const [modalIsOpen,setIsOpen] = useState(false);
  const [sellerItems, setSellerItems] = useState([]);
  const [allSellerList, setAllSellerList]  = useState([]);
  const [buttonSwitch, setButtonSwitch]  = useState(false);


  // useEffect(() => {

  //   setAllSellerList(props?.sellerList?.sort((a, b) => b.score - a.score).slice(0, 5));

  // }, [allSellerList]);

  const sellerList = props?.sellerList?.sort((a, b) => b?.seller?.score - a?.seller?.score).slice(0, 5);

  const _openSellerInfo = async (o) => {
    console.log(o,'--')
    GAEvent('Ranking', '랭킹', o.name);
    try {
      setIsOpen(true);
      setSellerInfo(o);
      const r = await seller.getSellerItem(o?.id);
      setSellerItems(r.data.data);
    } catch(e) {
      console.log(e);
    }
  }

  const _closeSellerInfo = (o) => {
    setIsOpen(false);
  }

  const _showAllList = () => {
    setButtonSwitch(!buttonSwitch);
  }

  useEffect(() => {
    if(buttonSwitch) {
      setAllSellerList(props?.sellerList);
    } else {
      setAllSellerList([]);
    }
  }, [buttonSwitch])

  return (
    <RankingWrap>
      <RankingContainer>
        <RankingTitle>
          <AlignListing>랭킹</AlignListing>
          <AlignListing>업체명</AlignListing>
          <AlignListing>스코어</AlignListing>
          {/* <AlignListing>노출수</AlignListing> */}
        </RankingTitle>
        {allSellerList.length !== 0 ? (
          <RankingList>
            {allSellerList?.map((o, i) => {
              return (
                <RankingListItem onClick={() => _openSellerInfo(o?.seller)}>
                  <AlignListing style={{color: '#808191'}}># {i + 1}</AlignListing>
                  <AlignListing style={{color: '#11142D', fontWeight: 600}}>{o?.seller?.name}</AlignListing>
                  <AlignListing>{o?.seller?.score}</AlignListing>
                  {/* <AlignListing>{o?.count?.count}</AlignListing> */}
                </RankingListItem>
              )
            })}
            <div>
              <ArrowButton style={{transform: 'rotate(180deg)'}} onClick={() => _showAllList()}>
                <img src={Arrow} />
              </ArrowButton>
            </div>
          </RankingList>
        ) : (
          <RankingList>
            {sellerList?.map((o, i) => {
              return (
                <RankingListItem onClick={() => _openSellerInfo(o?.seller)}>
                  <AlignListing style={{color: '#808191'}}># {i + 1}</AlignListing>
                  <AlignListing style={{color: '#11142D', fontWeight: 600}}>{o?.seller?.name}</AlignListing>
                  <AlignListing>{o?.seller?.score}</AlignListing>
                  {/* <AlignListing>{o?.count?.count}</AlignListing> */}
                </RankingListItem>
              )
            })}
            <div>
              <ArrowButton onClick={() => _showAllList()}>
                <img src={Arrow} />
              </ArrowButton>
            </div>
          </RankingList>
        )}
        
      </RankingContainer>
      <RankingDes>
        <p>
          * 업체의 순의는 실거래 횟수, 물량, 신뢰성 등을 크롤링 머신이 판단하여서 제공합니다.
        </p>
        <p>
          * 회원가입 이후 정확한 정보를 입력하시면 랭킹에 반영됩니다.
        </p>
      </RankingDes>
      <SellerModal modalIsOpen={modalIsOpen} modalIsClose={_closeSellerInfo} sellerInfo={sellerInfo} sellerItems={sellerItems} />
    </RankingWrap>
  )
}